import { z } from 'zod';

// Set by the account app's /verify-email page after it consumes the confirmation token, which is
// where the emailed link lands because it has to work for a signed-out therapist. A successful
// verification lands on the Dashboard instead, so it never reaches this page.
export const emailVerificationOutcomeSchema = z.enum(['expired', 'failed']);

export const profileSearchSchema = z.object({
    emailVerification: emailVerificationOutcomeSchema.optional(),
});

export type EmailVerificationOutcome = z.infer<typeof emailVerificationOutcomeSchema>;
